<template>
  <div
    id="app"
    :class="{ dark }"
    :style="{ height: `${height}px` }"
  >
    <TheHeader @sidebar-opened="$refs.chat.close()" />
    <div class="flex flex-1">
      <TheSidebar
        v-if="isLoggedIn"
        :class="{ hidden: !dark }"
        class="sm:block"
      />
      <div class="w-full h-full">
        <TheWallpaper v-if="isLoggedIn" />
        <transition
          name="zoom"
          enter-active-class="animated zoomIn"
          leave-active-class="animated zoomOut"
        >
          <router-view />
        </transition>
      </div>
    </div>
    <TheFooter v-if="isLoggedIn" />
    <ChatWindow ref="chat" />
    <SectionLayoutWarning />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ChatWindow from '@/components/Chat/ChatWindow.vue'
import TheFooter from '@/components/Layout/TheFooter'
import TheHeader from '@/components/Layout/TheHeader'
import TheSidebar from '@/components/Layout/TheSidebar'
import TheWallpaper from '@/components/Layout/TheWallpaper'
import SectionLayoutWarning from '@/components/Layout/SectionLayoutWarning'

export default {
  name: 'NacsApp',

  components: { ChatWindow, SectionLayoutWarning, TheFooter, TheHeader, TheSidebar, TheWallpaper },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
      height: state => state.global.screenHeight,
    }),

    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },

  created() {
    window.addEventListener('resize', this.resize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    ...mapActions({
      resize: 'global/resize',
    }),
  },
}
</script>

<style lang="postcss">
#app {
  touch-action: manipulation;
  @apply flex flex-col bg-blue-darkest;
}
.handle {
  background-color: #256d92 !important;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  @apply bg-blue-light-navy;
}

::-webkit-scrollbar-corner {
  @apply bg-blue-darkest;
}

::-webkit-scrollbar-track {
  @apply ml-2 bg-blue-darkest;
}

.dark {
  & /deep/ ::-webkit-scrollbar-track {
    @apply bg-dark-black;
  }

  & /deep/ ::-webkit-scrollbar-corner {
    @apply bg-dark-black;
  }

  & /deep/ ::-webkit-scrollbar-thumb {
    @apply bg-blue;
  }
}
</style>

<style lang="scss">
$steps: 50;
.glitch {
  outline: none;
  &,
  * {
    animation: cray 10s infinite steps($steps);
    display: inline-block;
  }
}

@keyframes cray {
  @for $i from 1 to $steps {
    $per: 100% / $steps * $i;
    $weight: (100, 200, 300, 400, 500, 600, 700);
    $style: (normal, italic, normal, normal);
    $trans: (none, none, uppercase, lowercase, capitalize, none, none, none, none, none, none);

    $arrayW: random(7);
    $arrayS: random(4);
    $arrayD: random(7);
    $arrayT: random(11);

    #{$per} {
      font-weight: nth($weight, $arrayW);
      font-style: nth($style, $arrayS);
      text-transform: nth($trans, $arrayT);
    }
  }
}
</style>
